import Sidebar from './Sidebar'

const SidebarContainer = () => {
    return (
        <Sidebar />
    )
}

export default SidebarContainer